import script from "./PoliticaCookies.vue?vue&type=script&setup=true&lang=js"
export * from "./PoliticaCookies.vue?vue&type=script&setup=true&lang=js"

import "./PoliticaCookies.vue?vue&type=style&index=0&id=76a4b69c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76a4b69c"]])

export default __exports__